import { render, staticRenderFns } from "./WebsiteTable.vue?vue&type=template&id=1229385c&scoped=true&"
import script from "./WebsiteTable.vue?vue&type=script&lang=js&"
export * from "./WebsiteTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1229385c",
  null
  
)

export default component.exports